/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Col_Created_ByInputs */

const vi_cdo_col_created_by = /** @type {(inputs: Cdo_Col_Created_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người tạo`)
};

/**

* @param {Cdo_Col_Created_ByInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_col_created_by = /** @type {((inputs?: Cdo_Col_Created_ByInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Col_Created_ByInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_col_created_by(inputs)
});